module.exports = __webpack_public_path__ + "img/back9.01acfc4b.jpg";